module.exports = __webpack_public_path__ + "img/about_posh_12.10bc6fca.png";